export default {
    title: "Partage de statistique opérationnel",
    message: "Tout est bon ! Merci de t'être reconnecté, le partage de statistiques est de nouveau opérationnel.",
};
